module.exports = __webpack_public_path__ + "img/skillset-gem-1.b2a57f6a.png";